const CORPORATE_GIFTING_URL = "/corporate-gifting";
const CORPORATE_GIFTING_TEXT = "ENQUIRY";
const BLOG_URL = "THE CIRCLE";
const CIRCLE_PROGRAM_URL = "/circle";
const CIRCLE_PROGRAM_TEXT = "THE CIRCLE";
const PRODUCT_VERIFICATION_TEXT = "PRODUCT VERIFICATION";
const PRODUCT_VERIFICATION_URL = "https://genuine.wildcraft.com/";

export {
  CORPORATE_GIFTING_URL,
  CORPORATE_GIFTING_TEXT,
  BLOG_URL,
  CIRCLE_PROGRAM_URL,
  CIRCLE_PROGRAM_TEXT,
  PRODUCT_VERIFICATION_TEXT,
  PRODUCT_VERIFICATION_URL,
};
